import Axios from "axios";
import QueryOptions from "../sal-ui/QueryOptions";
import PagedResult from "./PagedResult";
import AiTier from "../domain/AiTier";

class AiTierService {

    readonly basePath = "/ai-tiers";

    public add(aiTier: AiTier): Promise<string> {
        return Axios.post(`${this.basePath}`, aiTier).then(value => value.data.id);
    }

    public update(id: string, aiTier: AiTier): Promise<void> {
        return Axios.put(`${this.basePath}/${id}`, aiTier);
    }

    public get(id: string): Promise<AiTier> {
        return Axios.get(`${this.basePath}/${id}`)
            .then(value => AiTier.fromPOJO(value.data));
    }

    public delete(aiTier: AiTier): Promise<void> {
        return Axios.delete(`${this.basePath}/${aiTier.id}`);
    }

    public getList(queryOptions: QueryOptions): Promise<PagedResult<AiTier>> {
        return Axios.get(`${this.basePath}?${queryOptions.toQueryParams()}`)
            .then(value => {
                const objectList: AiTier[] = [];

                value.data.data.forEach((objectJson: object) => {
                    objectList.push(AiTier.fromPOJO(objectJson));
                });

                return new PagedResult(value.data.total, objectList);
            });
    }
}

export default AiTierService;
